module.exports = __webpack_public_path__ + "img/products.119236b.svg";